import { request } from 'utils/request';

export const GET_ACCOUNT = 'GET_ACCOUNT';
export const SET_ACCOUNT = 'SET_ACCOUNT';


export function getAccount() {
  return (dispatch) => dispatch(request({
    url: '/v1/account'
  })).then(
    (res) => {
      dispatch(setAccount(res.data));
      return res;
    }
  );
}


export function setAccount(account) {
  return {
    account,
    type: SET_ACCOUNT
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/account.js